import React, {useContext, useEffect, useState} from "react";
// @ts-ignore
import {useHistory, useLocation, useParams} from "react-router-dom";
import {RankingsAndLevelsMapContext} from "../../contexts/RankingsAndLevelsMapContext";
import {RankingsAndLevelsContext} from "../../contexts/RankingsAndLevelsContext";
import RankingsAndLevelsUtils from "../../services/RankingsAndLevelsUtils";
import CountryNavbar from "../RankingsAndLevelsCountry/Components/CountryNavbar";
import Constants from "../../data/Constants";
import './CountryGraphicsStyles.css'
import CountryGraphicsComponent from "./CountryGraphicsComponent";
import {GlobalDataContext} from "../../contexts/GlobalDataContext";
import {CountryReportInfo} from "../../interfaces/RankingsAndLevelsInterfaces";
import styled from "styled-components";
import Colors from "../../assets/colors/Colors";

const CountryGraphicsContainerDiv = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    color: white;
    padding: 1% 2%;
    background-color: ${(props: {isLife: boolean}) => (props.isLife ? Colors.backgroundGray: Colors.backgroundWhite)};
`;

const baseUrl = Constants.routes.rankingsCountryGraphics;

const CountryGraphicsContainer: React.FC = () => {
    let { countryCode } = useParams();
    let history = useHistory();
    let location = useLocation();

    //@ts-ignore
    let {country, setCountry } = useContext(RankingsAndLevelsMapContext);
    // @ts-ignore
    const { isLife, setIsLife } = useContext(RankingsAndLevelsContext);
    // @ts-ignore
    const { last10YearReports, lastYearAvailable, allDataLoaded } = useContext(GlobalDataContext);

    const [countryInfo, setCountryInfo] = useState<CountryReportInfo>();

    useEffect(() => {
        setCountry(countryCode);
        RankingsAndLevelsUtils.handleQueryParams(location, history, isLife, setIsLife, baseUrl.replace(':countryCode', countryCode));
    }, []);

    useEffect(() =>{
        if(allDataLoaded){
            const lastReportAvailable = last10YearReports[lastYearAvailable];
            if(country && lastReportAvailable){
                const info = RankingsAndLevelsUtils.getCountryInfo(country, last10YearReports, lastReportAvailable, isLife);
                if(!info){
                    return history.push('/error');
                }
                setCountryInfo(info);
            }
        }
    }, [allDataLoaded, country]);

    return (
        <CountryGraphicsContainerDiv isLife={isLife}>
            <CountryNavbar backRoute={`${Constants.routes.rankingsMap}/${countryCode}`}/>
            <CountryGraphicsComponent countryInfo={countryInfo} />
        </CountryGraphicsContainerDiv>
    );
};

export default CountryGraphicsContainer;
